export default __webpack_public_path__ + "static/media/silubi-logo-grey.796cae0a.svg";